import { deliveryArc } from "@/content/homepage";

export default function HomeHero() {
  return (
    <section className="av-hero" aria-labelledby="av-hero-title">
      <div className="av-shell av-hero-grid">
        <div className="av-hero-main">
          <p className="av-kicker">Technology transformation with applied AI</p>
          <h1 id="av-hero-title">Transform operations with technology and AI.</h1>
          <p className="av-hero-copy">
            Averentia helps organisations improve critical operations. We plan
            the change, build the required systems and support implementation.
          </p>
          <div className="av-actions">
            <a
              className="av-button av-button-dark"
              href="https://calendly.com/ritwik-averentia"
              target="_blank"
              rel="noreferrer"
            >
              Discuss your priorities <span aria-hidden="true">↗</span>
            </a>
            <a className="av-text-link" href="#selected-work">
              View case studies <span aria-hidden="true">↓</span>
            </a>
          </div>
        </div>

        <aside className="av-mandate" aria-label="What we do">
          <p className="av-label">What we do</p>
          <p>
            We work with leadership and delivery teams to move transformation
            programmes from plan to day-to-day operation.
          </p>
        </aside>
      </div>

      <ol className="av-delivery-arc" aria-label="Transformation delivery arc">
        {deliveryArc.map((step, index) => (
          <li key={step}>
            <span>{String(index + 1).padStart(2, "0")}</span>
            {step}
          </li>
        ))}
      </ol>
    </section>
  );
}
